export const EXAMPLE_POST_1 = 32
export const EXAMPLE_POST_2 = 68
export const EXAMPLE_POST_3 = 301
export const EXAMPLE_POST_4 = 256
export const EXAMPLE_POST_5 = 155

export const POINTED_TILE = 201